<template>
    <div class="parent-magazine-settings">
        <div class="header">
            <h4 class="title">{{ $t('magazine.page.parent_page.title') }}</h4>
            <b-button
                class="btn-toggle-parents-settings"
                variant="link"
                @click="showDeadlineModal">
                {{ $t('common.edit') }}
            </b-button>
            <design-2021-magazine-parent-url-deadline-modal-component
                :magazine-id="magazineIn.id"
                @deadline-updated="updateDeadline"
                ref="parentPageDeadlineModal">
            </design-2021-magazine-parent-url-deadline-modal-component>
        </div>

        <ul class="settings-overview">
            <li>
                <span class="label">{{ $t('magazine.congratulations_page.deadline') }}:</span>
                {{
                    magazine.parent_page_deadline !== null
                        ? $options.filters.date_written(magazine.parent_page_deadline)
                        : $t('magazine.page.parent_page.no_deadline')
                }}
            </li>

            <li v-if="magazine.parent_page_deadline && $authUser.isAdmin()">
                <span class="label">{{ $t('magazine.congratulations_page.count') }}:</span>
                {{ magazineIn.parent_pages.length }}
            </li>
        </ul>

        <div v-if="magazine.parent_page_deadline">
            <b-input-group class="public-url d-none d-lg-flex">
                <template v-slot:append>
                    <b-button
                        class="btn-copy btn-copy-to-clipboard remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon"
                        :title="$t('profile.copy_URL')"
                        @click.stop.prevent="copyUrl">
                    </b-button>
                </template>
                <b-form-input
                    readonly
                    aria-readonly="true"
                    :ref="refName"
                    :id="refName"
                    :value="url"
                    type="text">
                </b-form-input>
            </b-input-group>
            <b-button
                class="btn-copy btn-copy-to-clipboard d-block d-lg-none"
                variant="primary-icon-only"
                @click.stop.prevent="copyUrl">
                <i class="fas fa-copy"></i> {{ $t('profile.copy_URL') }}
            </b-button>

            <b-button
                class="btn-images btn-go-to-parent-page-overview"
                v-if="$authUser.isAdmin()"
                variant="primary"
                @click="toParentPageOverview">
                {{ $t('magazine.congratulations_page.pages_overview') }}
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-magazine-parent-url-component',
    props: {
        magazineIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            magazine: this.magazineIn,
            deadlineEdit: false,
            parentPageDeadlineDate: null,
            parentPageDeadlineTime: null,
            refName: `parent-page-url-${this.magazineIn.id}`,
        };
    },
    mounted() {
        if (this.magazineIn.parent_page_deadline) {
            /// set the local vars
        }
    },
    computed: {
        url() {
            return this.routes.baseUrl() + '/felicitaties/' + this.magazineIn.id + '/' + this.magazineIn.uuid;
        },
    },
    methods: {
        toParentPageOverview() {
            window.location.href = this.routes.magazineParentPageOverview(this.magazineIn.id);
        },

        showDeadlineModal() {
            const deadline = {
                date:
                    this.magazine.parent_page_deadline !== null
                        ? this.magazine.parent_page_deadline.split(' ')[0]
                        : null,
                time:
                    this.magazine.parent_page_deadline !== null
                        ? this.magazine.parent_page_deadline.split(' ')[1]
                        : null,
            };
            this.$refs.parentPageDeadlineModal.show(deadline);
        },

        updateDeadline(deadlineDateTime) {
            this.magazine.parent_page_deadline = deadlineDateTime;
        },

        copyUrl() {
            let urlCopy = document.getElementById(this.refName);
            urlCopy.select();
            const success = document.execCommand('copy');

            if (success) {
                this.dismissTimer = this.dismissSecs;
            }
            window.getSelection().removeAllRanges();
        },
    },
};
</script>

<style scoped lang="scss">
.parent-magazine-settings {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    border-top: 3px dotted $border-color;
    padding-top: map-get($grid-gutter-spacing, 'twenty-one');

    p {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .btn-toggle-parents-settings {
        font-size: $default-font-size;
        line-height: 1;

        &:hover {
            color: var(--nav-link-color);
            font-weight: $font-weight-medium;
        }
    }
}

.btn-copy {
    padding: map-get($grid-gutter-spacing, 'ten');
    font-size: 1.125rem;
}

.settings-overview {
    list-style: none;
    padding-left: 0;

    .label {
        display: inline-block;
        width: 150px;
        margin-right: map-get($grid-gutter-spacing, 'five');
    }
}

.btn-go-to-parent-page-overview {
    margin-top: $grid-gutter-width;
}
</style>
